import { ArrowRight } from "lucide-react";
import { imgSet, imgUrl, useContent } from "@/lib/content";
import { Reveal, SectionHead } from "./Reveal";

export const Treatments = ({ onPickTab }) => {
  const t = useContent().data.treatments;
  return (
    <section className="section" id="services" data-testid="treatments-section">
      <div className="wrap">
        <SectionHead eyebrow={t.eyebrow} title={t.title} text={t.text} />
        <div className="cards" data-testid="treatment-cards">
          {t.cards.map((c, i) => (
            <Reveal key={`${c.title}-${i}`} delay={i * 0.08} className="card-wrap">
              <article className="card" data-testid={`treatment-card-${c.category || i}`}>
                <img loading="lazy" src={imgUrl(c.image, 800)} srcSet={imgSet(c.image)} sizes="(min-width: 850px) 33vw, 80vw" alt={c.title} />
                <div className="inside">
                  <h3>{c.title}</h3>
                  <p>{c.text}</p>
                  <a href="#prices" onClick={(e) => { if (c.category) { e.preventDefault(); onPickTab(c.category); } }} data-testid={`treatment-card-${c.category || i}-link`}>
                    {c.cta} <ArrowRight size={13} />
                  </a>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
        <p className="swipe-hint">Swipe to see more</p>
      </div>
    </section>
  );
};
